import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-106fa878")

_pushScopeId("data-v-106fa878")
const _hoisted_1 = {
  "data-testid": "pickup-schedule-config-section-special-schedule",
  class: "flex flex-col gap-3 p-4 rounded-xl border border-gray-lp-400 bg-white mt-3"
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-bold text-gray-lp-300" }
const _hoisted_5 = {
  key: 0,
  class: "relative inline-flex items-center"
}
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "py-2 font-normal text-12px font-montserrat" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-lg font-bold" }, "+", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col mt-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SpecialDateRow = _resolveComponent("SpecialDateRow")!
  const _component_PickScheduleModal = _resolveComponent("PickScheduleModal")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toggle, {
          "model-value": _ctx.enabled,
          disabled: _ctx.loading,
          class: "special-toggle",
          "data-testid": "pickup-schedule-config-toggle-special-schedule",
          "onUpdate:modelValue": _ctx.onToggleEnabled
        }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.title") || "Jadwal khusus"), 1),
        (!!_ctx.tooltipDescription)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("img", {
                src: 
              require(`@/app/ui/assets/svg/${
                _ctx.isActiveTooltip ? 'info-red' : 'info'
              }.svg`)
            ,
                class: "ml-1 h-4 xxl:h-5 cursor-pointer",
                alt: "info",
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event))),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event)))
              }, null, 40, ["src"]),
              _createVNode(_component_OverlayPanel, {
                ref: "opTooltip",
                appendTo: "body",
                class: "w-1/4",
                style: {
              backgroundColor: _ctx.isDarkMode ? '#4D4D4D' : '#ffffff',
              color: _ctx.isDarkMode ? '#ffffff' : '#4D4D4D'
            }
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_6, [
                    _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
                      [_directive_sanitize_html, _ctx.tooltipDescription]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["style"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.enabled)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_ctx.dates.length > 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  "data-testid": "pickup-schedule-config-link-reset-special-schedule",
                  class: "special-action text-sm font-semibold transition-colors focus:outline-none",
                  disabled: _ctx.loading,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
                }, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.reset") || "Reset"), 9, ["disabled"]))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              "data-testid": "pickup-schedule-config-button-add-special-date",
              class: ["inline-flex items-center gap-1.5 px-3 py-2 text-sm font-bold rounded-lg border transition-all", 
            _ctx.isMaxDates
              ? 'border-gray-lp-400 text-gray-lp-500 bg-gray-lp-1000 cursor-not-allowed'
              : 'special-action special-action-border hover:bg-red-50'
          ],
              disabled: _ctx.isMaxDates || _ctx.loading,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOpenModal && _ctx.onOpenModal(...args)))
            }, [
              _hoisted_9,
              _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.addDate") ||
              "Pilih tanggal Pick Up"), 1)
            ], 10, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.enabled && _ctx.dates.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedDates, (item) => {
            return (_openBlock(), _createBlock(_component_SpecialDateRow, {
              key: item.date,
              date: item.date,
              "date-label": _ctx.formatDateLabel(item.date),
              slots: item.slots,
              disabled: _ctx.loading,
              "slot-start-hour": _ctx.slotStartHour,
              "slot-end-hour": _ctx.slotEndHour,
              "slot-interval-minutes": _ctx.slotIntervalMinutes,
              "onUpdate:slots": ($event: any) => (_ctx.onUpdateSlots(item.date, $event)),
              onRemoveDate: ($event: any) => (_ctx.onRemoveDate(item.date))
            }, null, 8, ["date", "date-label", "slots", "disabled", "slot-start-hour", "slot-end-hour", "slot-interval-minutes", "onUpdate:slots", "onRemoveDate"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PickScheduleModal, {
      open: _ctx.modalOpen,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalOpen = $event)),
      "existing-dates": _ctx.existingDates,
      "slot-start-hour": _ctx.slotStartHour,
      "slot-end-hour": _ctx.slotEndHour,
      "slot-interval-minutes": _ctx.slotIntervalMinutes,
      onSave: _ctx.onModalSave
    }, null, 8, ["open", "existing-dates", "slot-start-hour", "slot-end-hour", "slot-interval-minutes", "onSave"])
  ]))
})